module.exports = __webpack_public_path__ + "images/avatars/female/20.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/20.png
// module id = wuZI
// module chunks = 153